import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function OrderProgressbar({ trackOrder }) {
  //console.log(trackOrder)
  const [barClass, setBarclass] = useState('');
  const [styles, setStyles] = useState('');
  const trackBasket = useSelector((state) => state.track);
  let trackOrd = trackBasket.track;

  useEffect(() => {

    if (trackOrd === 0) {
      setBarclass("bg-danger");
      setStyles('1%')
    }
    else if (trackOrd === 1) {
      setBarclass("bg-danger");
      setStyles(Math.floor(1 / 6 * 100).toString() + '%')
    }
    else if (trackOrd === 2) {
      setBarclass("bg-warning");
      setStyles(Math.floor(2 / 6 * 100).toString() + '%')
    }
    else if (trackOrd === 3) {
      setBarclass("bg-warning");
      setStyles(Math.floor(3 / 6 * 100).toString() + '%')
    }
    else if (trackOrd === 4) {
      setBarclass("bg-primary");
      setStyles(Math.floor(4 / 6 * 100).toString() + '%')
    }
    else if (trackOrd === 5) {
      setBarclass("bg-primary");
      setStyles(Math.floor(5 / 6 * 100).toString() + '%')
    }
    else if (trackOrd === 6) {
      setBarclass("bg-success");
      setStyles(Math.floor(100).toString() + '%')
    }
  }, [trackOrd]);

  const cstyles = {
    width: styles
  }
  //console.log(barClass)
  return (
    <>
      <div className="progress">
        <div className={`progress-bar ${barClass}`} role="progressbar" style={cstyles} aria-valuenow="1" aria-valuemin="0" aria-valuemax="6"></div>
      </div>
    </>
  );
}
